<p-dialog header="{{ 'ReceiptForm.Button.WarehousingAbnormal' | translate }}" [(visible)]="isVisible" appendTo="body"
  (visibleChange)="dialogVisibleChange($event)" [modal]="true" [draggable]="false" [resizable]="false"
  [contentStyle]="isRwd ? {width: '80vw'} : {width: '50vw'}" >
  <div>
    <form [formGroup]="remainingSkuForm" class="my-1">
      <div>
        <div class="p-fluid grid">
          <div class="col-3 md:col-3 column-label p-text-center"><strong>Sku</strong></div>
          <div class="col-3 md:col-3 column-label p-text-center"><strong>Qty</strong></div>
          <div class="col-6 md:col-6 column-label p-text-center">
            <span class="icon" (click)="addItem()"><i class="fas fa-plus"></i></span>
          </div>
        </div>
      </div>
      <div formArrayName="remainingSkuItemForms" class="mt-3">
        <div *ngFor="let item of remainingSkuItemForms.controls; let i = index">
          <div class="p-fluid grid" [formGroupName]="i">
            <div class="field col-3 md:col-3">
              <input type="text" pInputText formControlName="sku" />
            </div>
            <div class="field col-3 md:col-3">
              <input type="number" pInputText formControlName="qty" />
            </div>
            <div class="field col-3 md:col-3 p-text-center">
              <button pButton pRipple icon="pi pi-trash" label="{{ 'Common.Button.Delete' | translate}}"
                    [className]="'p-button p-button-danger' + (isRwd ? ' p-button-rounded p-button-text p-button-icon-only' : '')"
                    (click)="deleteItem(i)"></button>
            </div>
            <div class="field col-3 md:col-3 p-text-center">
              <button pButton pRipple icon="pi pi-file-o" label="{{ 'Common.Button.FileUpload' | translate}}"
                    [className]="'p-button p-button-success' + (isRwd ? ' p-button-rounded p-button-text p-button-icon-only' : '')"
                    (click)="showFileUploadDialog(i)"></button>
            </div>
          </div>
        </div>
      </div>

      <laas-file-upload-dialog #fileDialog [title]="'ReceiptForm.Button.WarehousingAbnormal'"
        (saveDataChanges)="saveFile($event)" (restoreFileData)="restoreFileData()">
      </laas-file-upload-dialog>
      <div class="p-d-flex p-jc-end p-ai-center">
        <button pButton pRipple label="{{ 'Common.Button.Confirm' | translate }}" class="p-button-sm" (click)="confirmBtnClick($event)"></button>
      </div>
    </form>
  </div>
</p-dialog>
